import { Injectable } from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class CreatePowerbiReportCommandHandler implements IPlatformCommandHandler {
  sourceMap: any;
  constructor(
    private dialogService: DialogService,
    private snackBarService: SnackBarService,
    private fuseSplashScreenService: FuseSplashScreenService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const parentId = command.fieldValues['ParentId'] as string;
    const fileExtensionTypes = command.fieldValues['FileExtensionTypes'] as string[];
    const isClientDrive = command.fieldValues['IsClientDrive'] as boolean;
    const dialogueModel = DialogModel.create('Create New Power BI Report', 'AddPowerBiReportDialogComponent', {
      recordTitle: '',
      parentId: parentId,
      fileExtensionTypes: fileExtensionTypes,
      isClientDrive: isClientDrive
    }, '800px', '700px', true);
    this.dialogService.showOkCancelDialog(dialogueModel).pipe(take(1)).subscribe(res => {
      console.log('Dialog response: ', res);
      if (res.action === 'OK') {
        command.fieldValues['ReportTitle'] = res.data.input.title;
        command.fieldValues['ReportMapTypeId'] = res.data.input.reportType.id;
        command.fieldValues['ReportTableMappings'] = res.data.input.reportType;
        // const selectedFiles = res.data.input.selectedFiles;
        // const tableMappings = res.data.input.tableMappings;
        // for (let i = 0 ; i < tableMappings.length; i++) {
        //   const tableName = tableMappings[i].tableName;
        //   command.fieldValues[tableName] = selectedFiles[i].fileEntryId;
        // }
        if (res.data.input.powerbiGraphId) {
          command.fieldValues['PowerBiGraphId'] = res.data.input.powerbiGraphId;
        }
        this.fuseSplashScreenService.show();
        //this.snackBarService.showInformation(`Your PowerBi report will be ready shortly and you will get another notification once done.`);
        handler.executeCommand(command);
      }
    });
    return true;
  }
}
